import React, { useState, useEffect } from "react";

const LocationPopup = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 4000);
        return () => clearTimeout(timer);
    }, []);

    const handleAllow = () => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const coords = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    localStorage.setItem("user_location", JSON.stringify(coords));
                    localStorage.setItem("akhandaa_location_preference", "allowed");
                    setIsVisible(false);
                },
                (error) => {
                    setIsVisible(false);
                }
            );
        } else {
            setIsVisible(false);
        }
    };

    const handleDeny = () => {
        localStorage.setItem("akhandaa_location_preference", "denied");
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        /* Positioning it to the right corner of the hero section area */
        <div className="fixed top-40 right-10 z-[200] animate-in fade-in slide-in-from-top-4 duration-700">
            {/* Speech Bubble Design based on user sketch */}
            <div className="relative">
                <div className="bg-white px-6 py-5 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.1)] border border-sky-100 flex flex-col items-start gap-4">
                    <h3 className="text-sm font-black text-slate-900 uppercase tracking-tighter">
                        Enable Location
                    </h3>
                    
                    <div className="flex gap-2">
                        <button 
                            onClick={handleAllow}
                            className="bg-sky-600 text-white font-bold px-5 py-2.5 rounded-full hover:bg-sky-700 transition-all text-[10px] shadow-lg shadow-sky-100 uppercase tracking-widest active:scale-95"
                        >
                            Allow
                        </button>
                        <button 
                            onClick={handleDeny}
                            className="bg-slate-50 text-slate-400 font-bold px-5 py-2.5 rounded-full hover:bg-slate-100 transition-all text-[10px] uppercase tracking-widest active:scale-95 border border-slate-100"
                        >
                            Don't Allow
                        </button>
                    </div>
                </div>

                {/* Speech bubble tail (pointing down or left based on visual balance) */}
                <div className="absolute -bottom-2 right-12 w-4 h-4 bg-white border-r border-b border-sky-100 rotate-45"></div>
            </div>
        </div>
    );
};

export default LocationPopup;
